export default "__VITE_ASSET__DbqIrFCA__"